const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
}

export { SORT_DIRECTION }
